import React, { useState } from "react";
import { texts } from "../lib/constants";

function QuizGroupsQuestions({
  language,
  userData,
  questions,
  setCurrentQuestionsGroup,
  setUserTypeForm,
  isActiveQuestionsGroups,
  setIsActiveQuestionsGroups,
  setIsActiveVotingGroups,
  isMobile,
  isTablet,
  setShowMenu
}) {
  const [isActive, setisActive] = useState();
  const updateCurrentGroup = (groupNumber) => {
    setCurrentQuestionsGroup(groupNumber);
    setIsActiveQuestionsGroups(true);
    setIsActiveVotingGroups();
    setisActive(groupNumber);
  };

  // SE DEFINEN LAS PREGUNTAS POR GRUPO Y EL INDICE DE LA ULTIMA PREGUNTA
  const NUMBER_OF_QUESTIONS = 5;
  const LAST_QUESTION_NUMBER = 25;

  return (
    <div>
      {questions?.map((question, key) => {
        let groupQuestionsNumber = Math.floor(key / NUMBER_OF_QUESTIONS + 1);
        let questionNumber = key + 1;
        const customKeys = ["1-5", "6-10", "11-15", "16-20", "21-25"];
        const questionKey = customKeys[Math.floor(key / NUMBER_OF_QUESTIONS)];
        if (key % NUMBER_OF_QUESTIONS === 0 && questionNumber <= LAST_QUESTION_NUMBER) {
          return (
            <div
              onClick={() => {
                if (
                  userData && userData?.questions
                    ? userData?.questions[
                        groupQuestionsNumber < 10
                          ? "G0" + groupQuestionsNumber
                          : "G" + groupQuestionsNumber
                      ]?.done !== true
                    : true
                ) {
                  updateCurrentGroup(key / NUMBER_OF_QUESTIONS + 1);
                  setUserTypeForm("questions");
                  window.scrollTo(0, 0);
                  setShowMenu(false);
                }
              }}
              className={
                groupQuestionsNumber === isActive && isActiveQuestionsGroups
                  ? "questions questions-selected text-body-2"
                  : "questions text-body-2"
              }
              key={key}
            >
              <div style={{ marginRight: isMobile || isTablet ? "12px" : 0 }}>
                {texts[language].questionGroupText} {questionKey}{" "}
              </div>
              {userData && userData?.questions ? (
                userData?.questions[
                  groupQuestionsNumber < 10
                    ? "G0" + groupQuestionsNumber
                    : "G" + groupQuestionsNumber
                ]?.done === true ? (
                  <div>
                    <img
                      style={{ paddingTop: "12px" }}
                      alt="check"
                      src="/assets/img/icon-success.png"
                    ></img>
                  </div>
                ) : userData?.questions[
                    groupQuestionsNumber < 10
                      ? "G0" + groupQuestionsNumber
                      : "G" + groupQuestionsNumber
                  ] ? (
                  <span>
                    {
                      Object.keys(
                        userData?.questions[
                          groupQuestionsNumber < 10
                            ? "G0" + groupQuestionsNumber
                            : "G" + groupQuestionsNumber
                        ]
                      ).length
                    }{" "}
                    <span> {texts[language].of} {NUMBER_OF_QUESTIONS}</span>
                  </span>
                ) : (
                  <div className="empty-div"></div>
                )
              ) : (
                <div className="empty-div"></div>
              )}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}

export default QuizGroupsQuestions;
